export default {
  YOUR_EVENTS: 'Vos événements',
  ADD_EVENTS: 'Ajouter un événement',
  NO_EVENTS: 'Vous n’avez pas encore d’événements ajoutés!',
  ENTER: 'Entrer',
  EVENT_NAME: 'Nom de l’événement',
  START_DATE: 'Date de début',
  END_DATE: 'Date de fin',
  LOCATION: 'Lieu',
  TIMEZONE: 'Fuseau horaire',
  EVENT_CONFIG: 'Configuration de l’événement',
  API_KEY: 'Clé API',
  ARCHIVE_DAYS: 'Jours d’archivage',
  ARCHIVE_DAYS_LABEL: 'Jours d’archivage après la fin de l’événement',
  GDPR_CONFIG: 'Configuration du GDPR',
  GDPR_CONSENT: 'Consentement GDPR',
  GDPR_TITLE: 'Titre du GDPR',
  GDPR_DESC: 'Description du GDPR',
  GDPR_APPROVE_LABEL: 'Label du bouton d’approbation GDPR',
  GDPR_CANCEL_LABEL: 'Étiquette du bouton d’annulation GDPR',
  ADD_EVENT: 'Ajouter un événement',
  ADD_EVENT_SUCCESS: 'Votre événement a été créé avec succès!'
}
